import {Injectable} from '@angular/core';
import {MenuCategory} from '../_models/menu-category';
import {SortableService} from './sortable-service';

@Injectable({
    providedIn: 'root'
})
export class MenuCategoryService extends SortableService<MenuCategory> {
    destination = 'menu-categories';

    findByOrgId(orgId) {
        return this.http.get(this.baseUrl() + `/organization/${orgId}`);
    }
}
